import LoginForm from "../../components/LoginForm"

const Connexion = () => {
    return(
        <main>
            <LoginForm/>
        </main>
    )

}
export default Connexion